import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(() => ({
  root: {
    cursor: 'pointer',
  },
}));
